module.exports = __webpack_public_path__ + "img/aesthetic.4ebd9f38.png";